module.exports = __webpack_public_path__ + "static/media/landing_hero3.a0e94b03.png";